import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CartDetail" })
export default class CartDetail extends Vue {
    public localizer: any = Localizer;
    public validationErrors: any[] = [];
    public isLoading: boolean = false;
    public isGAEventSent: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    public addQuantity(computedCartRow: any) {
        computedCartRow.cartRow.quantity ? computedCartRow.cartRow.quantity++ : computedCartRow.cartRow.quantity = 1;
        if (computedCartRow.cartRow.quantity > 100) {
            computedCartRow.cartRow.quantity = 100;
        }
        this.updateQuantity(computedCartRow);
    }

    public removeQuantity(computedCartRow: any) {
        computedCartRow.cartRow.quantity > 1 ? computedCartRow.cartRow.quantity-- : computedCartRow.cartRow.quantity = 1;
        this.updateQuantity(computedCartRow);
    }

    public getCart() {
        this.$store.dispatch("cartStore/getCart");
    }

    public async updateQuantity(computedCartRow: any) {
        this.isLoading = true;
        this.validationErrors = [];

        if (computedCartRow.cartRow.quantity == "") {
            let name = "Quantity_" + computedCartRow.product.code;
            this.validationErrors.push({ name: name, message: this.localizer.get("Cart.Common.Error_QuantityNotValid") });
        } else {
            try {
                await Axios.post(this.routes.StoreCart_UpdateQuantity, { productIdMaster: computedCartRow.product.idMaster, productQuantity: computedCartRow.cartRow.quantity, cartRowId: computedCartRow.cartRow.id });

                this.getCart();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoading = false;
    }

    public async remove(computedCartRow: any) {
        this.validationErrors = [];
        let deletedProduct = this.cart.computedCartRows.find(x => x.cartRow.id === computedCartRow.cartRow.id);

        try {
            await Axios.post(this.routes.StoreCart_RemoveProduct, { cartRowId: computedCartRow.cartRow.id });

            this.getCart();

            GTagHelper.sendCustomEvent("remove_from_cart", {
                currency: "EUR",
                value: deletedProduct.totalPrice,
                items: [
                    {
                        item_id: deletedProduct.product.code,
                        item_name: deletedProduct.product.title,
                        affiliation: "Mectronic Medicale",
                        currency: "EUR",
                        item_category: deletedProduct.product.categoryName,
                        price: deletedProduct.product.price,
                        quantity: deletedProduct.cartRow.quantity
                    }
                ]
            });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async setCouponCode() {
        this.isLoading = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.StoreCart_SetCouponCode, { couponCode: this.cart.coupon.code });

            this.getCart();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoading = false;
    }

    public updated() {
        this.$nextTick(function () {
            if (this.cart && !this.isGAEventSent) {
                var itemList = [];

                for (var computedCartRow in this.cart.computedCartRows) {
                    itemList.push({
                        item_id: this.cart.computedCartRows[computedCartRow].product.code,
                        item_name: this.cart.computedCartRows[computedCartRow].product.title,
                        affiliation: "Mectronic Medicale",
                        currency: "EUR",
                        item_category: this.cart.computedCartRows[computedCartRow].product.categoryName,
                        price: this.cart.computedCartRows[computedCartRow].unitPrice,
                        quantity: this.cart.computedCartRows[computedCartRow].cartRow.quantity
                    });
                }

                GTagHelper.sendCustomEvent("view_cart", {
                    currency: "EUR",
                    value: this.cart.totalWithCostsPrice,
                    items: itemList
                });

                this.isGAEventSent = true;
            }
        });
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2 }).format(data);
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};